import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FaUser, FaBirthdayCake, FaFemale, FaMapMarkerAlt, FaEnvelope, FaUsers, FaClipboardList, FaStar } from "react-icons/fa";

const ProfileInfo = () => {
  return (
    <Container className="">
      <Row className="mb-3 align-items-center">
        <Col xs="auto">
          <FaUser /> 
        </Col>
        <Col>Your Name is </Col>
        <Col>
          <Form.Group controlId="firstName">
            <Form.Control type="text" value="Firstname" readOnly />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="lastName">
            <Form.Control type="text" value="Lastname" readOnly />
          </Form.Group>
        </Col>
        <Col xs="auto">
          <Button variant="success">Save</Button>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col xs="auto"><FaBirthdayCake /></Col>
        <Col>You were born on <strong>April 8, 1990</strong></Col>
      </Row>

      <Row className="mb-2">
        <Col xs="auto"><FaFemale /></Col>
        <Col>You are a <strong>Female</strong></Col>
      </Row>

      <Row className="mb-2">
        <Col xs="auto"><FaMapMarkerAlt /></Col>
        <Col>Your postal code is <strong>110001</strong></Col>
      </Row>

      <Row className="mb-3">
        <Col xs="auto"><FaEnvelope /></Col>
        <Col>You are registered with us from <strong>shahparshiny@gmail.com</strong></Col>
      </Row>
        <hr/>
      <Row className="mb-3">
        <Col xs="auto"><FaEnvelope /></Col>
        <Col>For any assistance or queries, please send an email to <strong style={{ color: "green" }}>support@torfacts.com</strong></Col>
      </Row>
      <hr/>

      <Row className="mb-2">
        <Col xs="auto"><FaUsers /></Col>
        <Col>You have been a member since <strong>July 10, 2025</strong></Col>
      </Row>

      <Row className="mb-2">
        <Col xs="auto"><FaClipboardList /></Col>
        <Col>You have taken <strong>0</strong> surveys and completed <strong>0</strong> of them.</Col>
      </Row>

      <Row className="mb-2">
        <Col xs="auto"><FaStar /></Col>
        <Col>You've earned <strong>3000 points</strong> since you started.</Col>
      </Row>
    </Container>
  );
};

export default ProfileInfo;
